import React from 'react';
import { Link } from 'react-router-dom';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddPermissionButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="raised"
    component={Link}
    to={`/users_permissions_status/create/?user_id=${record.id}`}
    label="Add permissions"
    title="Add permissions"
  >
    <ChatBubbleIcon />
  </Button>
);

export default withStyles(styles)(AddPermissionButton);
